import { lazy } from 'react';

/** `/app/*` — 콘솔·학습 (동일 청크) */
export const LazyAppLayout = lazy(
  () => import(/* webpackChunkName: "app-console" */ '../layout/AppLayout'),
);
export const LazyDashboard = lazy(
  () => import(/* webpackChunkName: "app-console" */ '../components/Dashboard'),
);
export const LazyModelTraining = lazy(
  () => import(/* webpackChunkName: "app-console" */ '../components/ModelTraining'),
);
export const LazyFusionWorkspace = lazy(
  () => import(/* webpackChunkName: "app-console" */ '../components/FusionWorkspace'),
);
export const LazyOnboardingPage = lazy(
  () => import(/* webpackChunkName: "app-console" */ '../pages/OnboardingPage'),
);

/** 마케팅·제품선·파크웨이브 */
export const LazyParkwaveRootEntry = lazy(
  () => import(/* webpackChunkName: "marketing" */ '../components/parkwave/ParkwaveRootEntry'),
);
export const LazyParkwaveSiteNotFound = lazy(
  () => import(/* webpackChunkName: "marketing" */ '../components/parkwave/ParkwaveSiteNotFound'),
);
export const LazyParkwaveApplicationHub = lazy(
  () => import(/* webpackChunkName: "marketing" */ '../pages/parkwave/ParkwaveApplicationHub'),
);
export const LazyParkwaveIndustrialReports = lazy(
  () => import(/* webpackChunkName: "marketing" */ '../pages/parkwave/ParkwaveIndustrialReports'),
);
export const LazyParkwaveParkingPage = lazy(
  () => import(/* webpackChunkName: "marketing" */ '../pages/parkwave/ParkwaveParkingPage'),
);
export const LazyParkwaveAmPage = lazy(
  () => import(/* webpackChunkName: "marketing" */ '../pages/parkwave/ParkwaveAmPage'),
);
export const LazyParkwaveMilitaryPage = lazy(
  () => import(/* webpackChunkName: "marketing" */ '../pages/parkwave/ParkwaveMilitaryPage'),
);
export const LazySolutionAutoPark = lazy(
  () => import(/* webpackChunkName: "marketing" */ '../pages/solutions/SolutionAutoPark'),
);
export const LazySolutionAutoAm = lazy(
  () => import(/* webpackChunkName: "marketing" */ '../pages/solutions/SolutionAutoAm'),
);
export const LazySolutionAutoArms = lazy(
  () => import(/* webpackChunkName: "marketing" */ '../pages/solutions/SolutionAutoArms'),
);
export const LazySolutionAutoInfra = lazy(
  () => import(/* webpackChunkName: "marketing" */ '../pages/solutions/SolutionAutoInfra'),
);

/** `/docs/*` */
export const LazyDocsDevelopersHub = lazy(
  () => import(/* webpackChunkName: "docs" */ '../pages/docs/DocsDevelopersHub'),
);
export const LazyDocsProductLines = lazy(
  () => import(/* webpackChunkName: "docs" */ '../pages/docs/DocsProductLines'),
);
export const LazyDocsVisionAndAgent = lazy(
  () => import(/* webpackChunkName: "docs" */ '../pages/docs/DocsVisionAndAgent'),
);
export const LazyDocsVmsIotIntegration = lazy(
  () => import(/* webpackChunkName: "docs" */ '../pages/docs/DocsVmsIotIntegration'),
);
export const LazyDocsEdgeAndCloud = lazy(
  () => import(/* webpackChunkName: "docs" */ '../pages/docs/DocsEdgeAndCloud'),
);
export const LazyDocsApiAndSdk = lazy(
  () => import(/* webpackChunkName: "docs" */ '../pages/docs/DocsApiAndSdk'),
);

/** `/try` 데모 (DVOS 위젯 등) */
export const LazyLandingPage = lazy(
  () => import(/* webpackChunkName: "try-demo" */ '../components/LandingPage'),
);

export const LazyLoginForm = lazy(
  () => import(/* webpackChunkName: "auth" */ '../components/LoginForm'),
);
